import React from 'react'
import ReactDOM from 'react-dom'
import 'bootstrap/dist/css/bootstrap.css'
import App from './App'

// Suprimir erros de extensões Chrome e cookies YouTube em desenvolvimento
if (process.env.NODE_ENV === 'development') {
  const originalError = console.error;
  const originalWarn = console.warn;
  
  console.error = (...args) => {
    if (
      args[0] && 
      args[0].includes &&
      args[0].includes('listener indicated an asynchronous response')
    ) {
      return;
    }
    originalError.apply(console, args);
  };

  console.warn = (...args) => {
    if (
      args[0] && 
      args[0].includes &&
      (args[0].includes('__Secure-YEC') || 
       args[0].includes('SameSite') ||
       args[0].includes('cross-site context'))
    ) {
      return;
    }
    originalWarn.apply(console, args);
  };
}

ReactDOM.render(<App />, document.getElementById('root'))